import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const CreateProgramWrapper = styled.div`
  .key-input-accordion {
    .MuiAccordionSummary-expandIconWrapper {
      display: none;
    }

    .MuiAccordionSummary-root {
      padding: 0px;
    }
  }

  .information-box {
    ${responsive.MOBILE`
      flex-wrap: wrap;  
    `}
  }

  .view-invoice-btn {
    flex-grow: 1;
    text-align: right;

    ${responsive.MOBILE`
      flex-basis: 100%;
      margin-top: 16px;

      button {
        width: 100%;
      }
    `}
  }
`;

export const CreateProgramInformationWrapper = styled.div`
  .confirm-message {
    color: ${COLORS.cirrus_black10};
    line-height: 22px;
  }
`;
